import echo from "@/services/echo";

export default {
  install(Vue) {
    Vue.Echo = echo;
    Vue.prototype.Echo = echo;
    window.Echo = echo;
    Vue.prototype.$echo = echo;
  }
};
